import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getNewbuildingId } from '../../selectors/newbuildingHeader';
import { trackPhoneShow } from '../../tracking/newbuilding';
import { ENewbuildingCallPlaceType } from '../../types/newbuildingHeader';
import { NewbuildingCallButtonContainer } from '../NewbuildingCallButton';

export const NewbuildingHeaderFullscreenGalleryCallContainer: React.FC = () => {
  const newbuildingId = useSelector(getNewbuildingId);

  const onShowPhoneClick = React.useCallback(() => {
    if (newbuildingId) {
      trackPhoneShow({ newbuildingId, action: 'Open_jk_head_block' });
    }
  }, [newbuildingId]);

  return (
    <NewbuildingCallButtonContainer
      placeType={ENewbuildingCallPlaceType.NewbuildingHeaderInSerpFullscreenGallery}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'XS', beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" /> }}
      showPhoneStyles={{ size: 'XS' }}
    />
  );
};
